/**
 * This method takes any value and if typeof is string will trim the value, otherwise return original value.
 * Optional parameter to mutate value to string or return original value
 * @param value
 * @param mutateValue
 */

export default (value: any): any => {
  if (value && typeof value === 'string') {
    return value?.trim();
  }
  
  return value;
};
